import React from 'react';
import {
	SideBarCollapseButton,
	SideBarLogoImage,
	SideBarLogoWrapper,
} from './styles';
import { TbArrowBarToLeft, TbArrowBarToRight } from 'react-icons/tb';
import CelcoinLogo from 'components/Icons/CelcoinLogo';

interface ISideBarLogoProps {
	isCollapsed: boolean;
	setIsCollapsed: () => void;
}
export function SideBarLogo({
	isCollapsed,
	setIsCollapsed,
}: ISideBarLogoProps) {
	return (
		<SideBarLogoWrapper>
			<SideBarLogoImage isCollapsed={isCollapsed}>
				<CelcoinLogo />
			</SideBarLogoImage>
			<SideBarCollapseButton onClick={setIsCollapsed}>
				{!isCollapsed ? <TbArrowBarToLeft /> : <TbArrowBarToRight />}
			</SideBarCollapseButton>
		</SideBarLogoWrapper>
	);
}
